"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = LogoutButton;

var _react = _interopRequireDefault(require("react"));

var _solidAuthClient = _interopRequireDefault(require("solid-auth-client"));
/** Button that lets the user log out with Solid. */


function LogoutButton(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Log out' : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'solid auth logout' : _ref$className;
  return _react.default.createElement("button", {
    className: className,
    onClick: function onClick() {
      return _solidAuthClient.default.logout();
    }
  }, children);
}